export default __webpack_public_path__ + "static/media/Foot_left.e7638bad.svg";